const re = /^[A-Za-z]+$/;

export const validateName = (name: string): boolean =>
	re.test(String(name).toLowerCase());
